<template>
  <v-app>
    <router-view />
    <UDialog
      :show="dialogImprint"
      :actions="[]"
      title="Imprint"
      cancel-label="Close"
      @closeDialog="dialogImprint = false"
    >
      <div slot="body" class="dialog_imprint">
        <span v-html="imprint" />
      </div>
    </UDialog>
    <UDialog
      :show="dialogPrivacyPolicy"
      :actions="[]"
      title="Privacy Policy"
      width="800"
      cancel-label="Close"
      @closeDialog="dialogPrivacyPolicy = false"
    >
      <div slot="body" class="dialog_imprint">
        <span v-html="privacyPolicy" />
      </div>
    </UDialog>
    <USnackbar v-bind="snack" @unsnack="unsnack" />
    <v-footer height="auto" class="love-footer" color="rgb(250, 250, 250)">
      <v-card class="flex" flat tile>
        <v-card-actions class="justify-center love-text"
          >Made with
          <v-icon class="love-icon" color="secondary" size="20px"
            >favorite</v-icon
          >in&nbsp;
          <a href="https://www.trakken.de" target="_blank">Hamburg</a
          >&nbsp;-&nbsp;
          <a @click="dialogImprint = true">Imprint</a>&nbsp;-&nbsp;
          <a @click="dialogPrivacyPolicy = true">Privacy Policy</a>
        </v-card-actions>
      </v-card>
    </v-footer>
  </v-app>
</template>

<script>
import UDialog from "@/components/UDialog";
import USnackbar from "@/components/USnackbar";
import imprint from "!raw-loader!@/assets/imprint.html";
import privacyPolicy from "!raw-loader!@/assets/privacy_policy.html";

export default {
  components: {
    UDialog,
    USnackbar
  },
  data() {
    return {
      dialogImprint: false,
      dialogPrivacyPolicy: false,
      imprint,
      privacyPolicy
    };
  },
  computed: {
    snack() {
      return this.$store.state.general.snack;
    }
  },
  methods: {
    unsnack() {
      this.$store.dispatch("unsnack");
    }
  }
};
</script>

<style lang="scss">
.love-footer {
  border-color: transparent !important;
  .v-card {
    background-color: transparent !important;
  }
  position: absolute;
  height: 80px;
  width: 100%;
  bottom: 0;
}
.love-text {
  color: #999;
  font-size: 14px;
  a {
    color: #999;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
}
.love-icon {
  padding: 0 5px 1px 5px;
}
.dialog_imprint {
  a {
    color: #999;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
